module.exports = __webpack_public_path__ + "static/media/bestzap.62433f00.png";